export default "__VITE_PUBLIC_ASSET__02c667c5__"